export default "__VITE_ASSET__DcgYhne6__"